exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title-border-section[data-v-21bff140]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-bottom:10px}.title-border-section .l-title[data-v-21bff140]{padding-left:10px;position:relative;font-size:18px;line-height:18px}.title-border-section .l-title[data-v-21bff140]:before{position:absolute;left:0;top:0;bottom:0;content:\"\";width:3px;background-color:var(--systemMainColor)}.title-border-section .right[data-v-21bff140]{line-height:18px}", ""]);

// exports
